export const shuffleGamesController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        FETCH_SHUFFLE_GAMES: [
          {
            actions: ['getShuffleGame', 'categories_reload'],
            cond: 'isShuffleGamesListAlreadyLoaded',
            target: 'controllerIdle',
          },
          {
            target: 'fetchingShuffleGames',
          },
        ],
        SESSION_STATE_LOGGED_OUT: [
          {
            actions: 'clearShuffleGames',
          },
        ],
      },
    },
    fetchingShuffleGames: {
      invoke: {
        src: 'fetchShuffleGames',
        onDone: [
          {
            actions: [
              'saveFetchedShuffleGames',
              'getShuffleGame',
              'categories_reload',
            ],
            target: 'controllerIdle',
            cond: 'isShuffleGamesListFetchedSuccessfully',
          },
          {
            target: 'controllerIdle',
          },
        ],
      },
    },
  },
};
